import { render, staticRenderFns } from "./ProductsLayout.vue?vue&type=template&id=3dec9e44&"
import script from "./ProductsLayout.vue?vue&type=script&lang=js&"
export * from "./ProductsLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports